<template>
  <div class="home">
    <div class="con-lef">
      <SideBar/>
    </div>
    <div class="con-rig">
      <div class="rig-top">
        <MyHeader/>
      </div>
      <div ref="content" class="rig-con">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/pms/landlord/Header.vue";
import SideBar from "@/components/pms/landlord/SideBar.vue";
import {onMounted, ref} from "vue";
import store from "@/store/pms/landlord/index";

export default {
  components: {
    MyHeader,
    SideBar,
  },
  setup() {
    const content = ref();
    const collapseSign = store.watch(
        (state) => state.collapseSign,
        () => {
          setTimeout(() => {
            store.state.ContentWidth = content.value.clientWidth;
          }, 500);
        }
    );

    onMounted(() => {
      store.state.ContentHeight = content.value.clientHeight;
      store.state.ContentWidth = content.value.clientWidth;
      localStorage.setItem("ContentHeight", content.value.clientHeight);
      window.addEventListener("resize", function () {
        // 屏幕大小变化时执行的操作
        store.state.ContentHeight = content.value.clientHeight;
        store.state.ContentWidth = content.value.clientWidth;
        localStorage.setItem("ContentHeight", content.value.clientHeight);
      });
    });
    return {
      content,
      collapseSign,
    };
  },
};
</script>

<style lang="scss" scoped>
body {
  overflow: hidden;
}

.home {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;

  .con-lef {
    // position: absolute;
    // top: 0;
    // bottom: 0;
    // width: 200px;
    // border-right: 1px solid #f0f0f0;
  }

  .con-rig {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow-x: hidden;

    .rig-top {
      // z-index: 9999;
    }

    .rig-con {
      flex: 1;
      overflow: auto;
      padding: 10px;
      // background-color: #ffffff;
      // z-index: 999;
    }
  }
}
</style>
